import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import querystring from 'query-string';
import invariant from 'invariant';

const getContentByPage = (params) => {
    const { baseUrl, brandId, country, language, pageKey, options, clientId, coreMediaLocale } = params;
    invariant(baseUrl, 'baseUrl is a required param of getContentByPage()');
    invariant(brandId, 'brandId is a required param of getContentByPage()');
    invariant(country, 'country is a required param of getContentByPage()');
    invariant(language, 'language is a required param of getContentByPage()');
    invariant(pageKey, 'pageKey is a required param of getContentByPage()');
    invariant(clientId, 'clientId is a required param of getContentByPage()');

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const langId = coreMediaLocale ? coreMediaLocale : `${language}_${country.toUpperCase()}`;
    const optionalQuery = options ? `&${querystring.stringify(options)}` : '';
    const url = `${baseUrl}blueprint/servlet/contentbypage/v2/store/${localisedBrand}/key/${pageKey}?langId=${langId}${optionalQuery}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers }), undefined, clientId), 'getContentByPage');
};

export default getContentByPage;
